import React from "react";
import { ApplicationTable } from "./Components/ApplicationTable";

export const AllKYCContainer = () => {
  return (
    <div className="w-100">
      <ApplicationTable />
    </div>
  );
};
